import React, { useState, useEffect, useCallback } from 'react';
import cn from 'classnames';
import { Empty } from 'antd';
import SpinWrapper from '../../../../components/SpinWrapper/SpinWrapper';
import InfoBlock from '../InfoBlock/InfoBlock';
import SearchField from '../../../../components/SearchField/SearchField';
import DocumentList from './components/DocumentsList';
import UploadButton from '../../../../components/UploadButton/UploadButton';
import useCardPagination from '../../../../hooks/useCardPagination';
import { getReplacedString } from '../../../../helpers/getReplacedString';
import styles from './OfficeDocuments.module.scss';

const filterDocuments = ({ data, string, key = 'name' }) =>
  data.filter((item) => {
    const value = getReplacedString(string);
    const name = getReplacedString(item[key]);

    return name.includes(value);
  });

const OfficeDocuments = ({
  className,
  title = 'Документы',
  documents,
  onDeleteDocument,
  pageSize = 7,
  getAttachmentUrl,
  uploadButtonProps,
  loading = false,
  smallTitle = false,
  dark = true,
}) => {
  const [searchValue, setSearchValue] = useState('');
  const [filteredBySearchDocuments, setFilteredBySearchDocuments] = useState(
    []
  );

  useEffect(() => {
    let docs = [];

    if (Boolean(documents?.length)) {
      docs =
        searchValue.trim() !== ''
          ? filterDocuments({ data: documents, string: searchValue })
          : documents;
    }

    setFilteredBySearchDocuments(docs);
  }, [documents, searchValue]);

  const { shownItems, pagination } = useCardPagination(
    filteredBySearchDocuments,
    pageSize
  );

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };

  const handleDeleteDocument = useCallback(
    async (document) => {
      if (typeof onDeleteDocument === 'function') {
        await onDeleteDocument(document);
        setSearchValue('');
      }
    },
    [onDeleteDocument]
  );

  const handleAddDocument = useCallback(
    async ({ file }) => {
      if (typeof uploadButtonProps?.customRequest === 'function') {
        await uploadButtonProps.customRequest({ file });
        setSearchValue('');
      }
    },
    [uploadButtonProps]
  );

  return (
    <SpinWrapper spinning={loading}>
      <InfoBlock
        title={title}
        action={filteredBySearchDocuments.length > pageSize ? pagination : null}
        dark={dark}
        titleClassName={cn({ [styles.smallTitle]: smallTitle })}
        className={className}
      >
        {!shownItems.length ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ) : (
          <>
            {Boolean(documents?.length > pageSize) && (
              <SearchField
                placeholder="Поиск по названию документа"
                value={searchValue}
                onChange={handleSearchChange}
              />
            )}
            <DocumentList
              items={shownItems}
              allDocs={filteredBySearchDocuments}
              getAttachmentUrl={getAttachmentUrl}
              onDeleteDocument={
                typeof onDeleteDocument === 'function'
                  ? handleDeleteDocument
                  : undefined
              }
            />
          </>
        )}
        {uploadButtonProps && (
          <UploadButton
            {...uploadButtonProps}
            customRequest={handleAddDocument}
            className={styles.upload}
            buttonClassName={styles.uploadButton}
            buttonText="Добавить документ"
          />
        )}
      </InfoBlock>
    </SpinWrapper>
  );
};

export default OfficeDocuments;
